import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Schedule } from '@/types/Doctor';
import SelectableBox from './SelectableBox';

interface Props {
  setSelectedTimes: (time: string[]) => void;
  selectedTimes: string[];
  selectedDate?: Partial<Schedule>;
  schedules?: Schedule[];
  isWithAppointment?: boolean;
}

const TimeSection = ({
  setSelectedTimes,
  selectedTimes,
  selectedDate,
  schedules,
  isWithAppointment,
}: Props) => {
  const handleSetSelectedTimes = (time: string) => {
    if (!isWithAppointment) {
      setSelectedTimes([time]);
    } else if (selectedTimes.includes(time)) {
      const newTimes = selectedTimes.filter(t => t !== time);
      setSelectedTimes(newTimes);
    } else {
      setSelectedTimes([...selectedTimes, time]);
    }
  };

  const times = useMemo(() => {
    return schedules?.find(s => s.date === selectedDate?.date)?.times || [];
  }, [selectedDate, selectedDate]);

  return (
    <Grid container direction="row" spacing={2}>
      {times.map(time => (
        <Grid item xs={3} key={time}>
          <SelectableBox
            onClick={() => {
              handleSetSelectedTimes(time);
            }}
            isSelected={selectedTimes.includes(time)}
          >
            <p style={{ fontWeight: 400, margin: 0, padding: '6px' }}>
              {time.replace(':', '.')}
            </p>
          </SelectableBox>
        </Grid>
      ))}
    </Grid>
  );
};

export default TimeSection;
